/**
 * Client-side poll telemetry shared with the dev debug panel. `useVideoJob`
 * pushes one entry per summary poll; the panel (which renders in the global
 * layout, outside any one page's hook) reads them back here. Bounded, and only
 * ever consumed by the import.meta.env.DEV-only panel.
 */

export interface DevPollSample {
  videoId: string;
  at: number;
  latencyMs: number;
  status: string;
}

const MAX_SAMPLES = 500;
const LOG: DevPollSample[] = [];

export function pushPoll(sample: DevPollSample): void {
  LOG.push(sample);
  if (LOG.length > MAX_SAMPLES) LOG.shift();
}

export function recentPolls(): DevPollSample[] {
  return [...LOG];
}